export default "__VITE_ASSET__BbJzK7Xt__"